import axios from 'axios';
import { useQuery } from 'react-query';
import Cookies from 'js-cookie';

export const useQueryReportData = (
    options,
    userId,
    rangeStart,
    rangeEnd,
    activityRecord,
    status
) => {
    return useQuery(
        ['ClockRecordReportData'],
        async () => {
            const { data } = await axios.get(
                process.env.REACT_APP_SERVER +
                    `api/CollaboratorsClockRecords/Report/${userId}?rangeStart=${rangeStart}&rangeEnd=${rangeEnd}&activityRecord=${activityRecord}&status=${status}`,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            );
            return data;
        },
        options ? options : {}
    );
};
